import { z } from 'zod';

import { CriterionRecord } from 'src/types';
import { zodIssuesIntoErrorsMap } from 'src/utils/validation';
import { RISK_SCAN_SOURCE_TYPES } from 'src/utils/defaults/Constants';

const criterionSchema = z.object({
  name: z.string().trim().nonempty(),
  description: z.string().trim().nonempty(),
  search_filters: z.record(z.string(), z.any()),
  search_columns: z
    .array(z.string().trim().nonempty())
    .nullable()
    .transform((val) => (val?.length ? val : null)),
  api_field_paths: z
    .array(z.string().trim().nonempty())
    .nullable()
    .transform((val) => (val?.length ? val : null)),
  source: z.enum(RISK_SCAN_SOURCE_TYPES.map((type) => type.id) as [string, ...string[]]),
  datalake_expressions: z.record(z.string(), z.any()).nullable(),
});

export const createCriterionSchema = criterionSchema;

export const editCriterionSchema = criterionSchema;

export const getFormValidator = (kind: 'create' | 'edit') => (values: Partial<CriterionRecord>) => {
  const schema = kind === 'create' ? createCriterionSchema : editCriterionSchema;
  const validationResult = schema.safeParse(values);
  return validationResult.success ? {} : zodIssuesIntoErrorsMap(validationResult.error.issues);
};
